const isDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const baseURL = isDevelopment ? 'http://127.0.0.1:8001' : window.location.origin;
export default baseURL;
